import agronea from './img/agronea.png'
import iagrooldris from './img/iagrooldris.png'
import agrosebranice from './img/agrosebranice.png'
import agrodeck from './img/agrodeck.png'
const more = "Zobrazit více"

const allProjects = [
    {
        id: 1,
        image: iagrooldris,
        title: "I. Agro Oldřiš",
        desc: "Statická webová stránka pro I. Agro Oldřiš.",
        link: "https://agro-oldris.cz",
        more: more,
    },
    {
        id: 2,
        image: agronea,
        title: "Agronea a.s. Polička",
        desc: "Webové stránky pro Agronea a.s. Polička.",
        link: "https://www.agronea.cz",
        more: more,
    },
    {
        id: 3,
        image: agrosebranice,
        title: "Agro družstvo Sebranice",
        desc: "Webové stránky pro Agro družstvo Sebranice.",
        link: "https://agrosebranice.cz",
        more: more,
    },
        {
        id: 4,
        image: agrodeck,
        title: "AgroDeck",
        desc: "Webová aplikace pro správu zemědělských podniků",
        link: "https://agrodeck-public.vercel.app",
        more: more,
    },
]

export default allProjects